module.exports = __webpack_public_path__ + "img/0.05.fceaa529.png";